interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-8" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className="w-9 h-9 rounded-md border border-background-200 text-sm font-label text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            1
          </button>
          {start > 2 && <span className="text-foreground-400 px-1">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm font-label cursor-pointer transition-colors ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="text-foreground-400 px-1">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className="w-9 h-9 rounded-md border border-background-200 text-sm font-label text-foreground-700 hover:bg-background-100 cursor-pointer"
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}